<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">
                    Address
                </h2>
            </div>
            <div>
                <mat-icon *ngIf="form.pristine && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="form.pristine && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && !form.valid" class="header-toggle error">
                    close
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body-container mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address Line 1</mat-label>
                        <input type="text" matInput placeholder="Address 1" formControlName="address_line_1">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address Line 2</mat-label>
                        <input type="text" matInput placeholder="Address 2" formControlName="address_line_2">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>City</mat-label>
                        <input type="text" matInput placeholder="City" formControlName="city">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>State/Province</mat-label>
                        <mat-select formControlName="state">
                            <mat-option *ngFor="let state of states" [value]="state.value">{{ state.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Zip/Postal Code</mat-label>
                        <input type="text" matInput placeholder="Zip/Postal Code" formControlName="postal_code">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Country</mat-label>
                        <mat-select formControlName="country_id">
                            <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.display_text }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</mat-expansion-panel>